module.exports = __webpack_public_path__ + "img/doucan-logo.202984d0.png";